var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxDiscoveringNewWorlds01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-discovering-new-worlds-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1ZM6.31,8A1.51,1.51,0,0,0,5,8.83L4.38,10H3.23A9,9,0,0,1,4.52,7H9a.45.45,0,0,1,.5.5A.45.45,0,0,1,9,8Zm.05,11H9.59l2,2A9,9,0,0,1,6.36,19Zm7.78,1.73L11,17.59A2,2,0,0,0,9.59,17H4.52A8.94,8.94,0,0,1,3,12H4.38a2,2,0,0,0,1.79-1.1l.45-.9H9a2.45,2.45,0,0,0,2.5-2.5A2.45,2.45,0,0,0,9,5H6.36A8.91,8.91,0,0,1,12,3a9,9,0,0,1,8.05,5H18.54a2,2,0,0,0-1.67.89L15.46,11H14a2.5,2.5,0,0,0,0,5h2.38l.45.89A2,2,0,0,0,18.62,18h.07A9,9,0,0,1,14.14,20.73ZM20.05,16H18.62L18,14.83A1.49,1.49,0,0,0,16.69,14H14a.5.5,0,0,1,0-1h1.73A1.49,1.49,0,0,0,17,12.33L18.54,10h2.23A8.76,8.76,0,0,1,21,12,9,9,0,0,1,20.05,16Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxDiscoveringNewWorlds01);
export default __webpack_public_path__ + "static/media/24px-discovering-new-worlds-01.c33dec3ac1648c6e04297f8472667d8a.svg";
export { ForwardRef as ReactComponent };